/**
 * 模組頁面代碼 : 1310-UI-05
 * 頁面說明 : 梯控設定新增修改視窗
 * @module web/modules/building/components/ControlDeviceModal
 */

// ----- import from npm modules -----
import React, { useState, useEffect } from 'react';

// ----- constants -----
const DEVICE_NEW = 'new';
const DEVICE_EDIT = 'edit';

const RESPONSE_OK = 200;
const TITLE_CTRLDEV_NEW = '新增梯控設定';
const TITLE_CTRLDEV_EDIT = '修改梯控設定';

const ControlDeviceModal = React.forwardRef((props, ref) => {
    const { mode, buildingId, controlDevice } = props;
    let modalIcon = mode === DEVICE_NEW? '#ico-plus' : '#ico-edit';
    let modalTitleText = mode === DEVICE_NEW? TITLE_CTRLDEV_NEW : TITLE_CTRLDEV_EDIT;

    // 初始化state
    const [formValues, setFormValues] = useState({
        modalDeviceName: '',
        modalDeviceType: 'M',
        modalDeviceHostnameCheck: true,
        modalDeviceHostname: '',
        modalDeviceMacCheck: true,
        modalDeviceMac: '',
    });

    const [invalidShow, setInvalidShow] = useState('none');

    // Handle change event
    const handleChange = (event) => {
        const target = event.target;
        let value = target.value;

        if (target.type === 'radio') {
            value = target.id.slice(-1);
        }

        setFormValues({
            ...formValues,
            [target.name]: target.type === 'checkbox' ? target.checked : value,
        });
    };

    // 使用useEffect在controlDevice改變才更新formValues
    useEffect(() => {
        setFormValues({
            modalDeviceName: controlDevice? controlDevice.deviceName : '',
            modalDeviceType: controlDevice? controlDevice.deviceType : 'M',
            modalDeviceHostnameCheck: true,
            modalDeviceHostname: controlDevice && controlDevice.deviceHost !== null? controlDevice.deviceHost : '',
            modalDeviceMacCheck: true,
            modalDeviceMac: controlDevice && controlDevice.deviceMac !== null? controlDevice.deviceMac : '',
        });
        setInvalidShow('none');
    }, [controlDevice]);

    const handleSubmit = (e) => {
        e.preventDefault();
        e.stopPropagation();
        const form = e.currentTarget;

        if (form.checkValidity() === false) {
            setInvalidShow('block');
            form.classList.add('was-validated');
            return;
        }

        // 建立 FormData 讀取表单的值
        const formData = new FormData(form);

        // 建立角色物件
        const saveControlDevice = {
            deviceId: mode === DEVICE_NEW? null : controlDevice.deviceId,
            buildingId: buildingId,
            deviceName: formData.get('modalDeviceName'),
            deviceType: formData.get('modalDeviceType'),
            deviceHost: formData.get('modalDeviceHostname'),
            flgStatus: mode === DEVICE_NEW? 'A' : controlDevice.flgStatus,
            deviceMac: formData.get('modalDeviceMac'),
            useHostname: 1,
            useMac: 1,
            deviceCode: formData.get('modalDeviceMac').replace(/:/g, ''),
        };

        // 呼叫父層元件的新增或修改角色函式
        if (mode === DEVICE_NEW) {
            props.addControlDevice(saveControlDevice).then((response) => {
                const statusCode = response.payload.code;
                if (statusCode !== RESPONSE_OK) {
                    $(ref.current).modal('hide');
                    props.onErrorHandle(TITLE_CTRLDEV_NEW, response.payload);
                } else {
                    // 调用 fetchControlDeviceList and Hide the modal
                    props.fetchControlDeviceList(buildingId).then(() => {
                        props.setNeedControlDeviceListLoad(true);
                        $(ref.current).modal('hide');
                    });
                }
            });
        } else if (mode === DEVICE_EDIT) {
            props.editControlDevice(saveControlDevice).then((response) => {
                const statusCode = response.payload.code;
                if (statusCode !== RESPONSE_OK) {
                    $(ref.current).modal('hide');
                    props.onErrorHandle(TITLE_CTRLDEV_EDIT, response.payload );
                } else {
                    // 调用 fetchRLit and Hide the modal
                    props.fetchControlDeviceList(buildingId).then(() => {
                        props.setNeedControlDeviceListLoad(true);
                        $(ref.current).modal('hide');
                    });
                }
            });
        }
    }

    const syncControlDeviceMac = () => {
        const { modalDeviceHostname } = formValues;
        props.syncControlDeviceMac(modalDeviceHostname).then((response) => {
            const statusCode = response.payload.code;
            if (statusCode !== RESPONSE_OK) {
                props.onErrorHandle('同步MAC address', response.payload);
            }
        });
    }

    return (
        <div ref={ref}
            className="modal fade"
            id="modalControlDevice"
            data-bs-backdrop="static"
            data-bs-keyboard="false"
            tabIndex="-1"
            aria-labelledby="modalControlDeviceLabel"
            aria-hidden="true"
        >
            <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable">
                <form className="modal__form modal-content needs-validation" id="modalControlDeviceeForm" onSubmit={handleSubmit}>
                    <div className="modal-header">
                        <h1 className="modal-title fs-5" id="modalControlDeviceLabel">
                            <div className="modal__title__badge">
                                <svg className="badge__icon" aria-hidden="true">
                                    <use href={modalIcon}></use>
                                </svg>
                            </div>
                            <div className="modal__title__text">{modalTitleText}</div>
                        </h1>
                        <button type="button" className="btn-close btn-cancel" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div className="modal-body">
                        <div className="d-flex flex-column gap-3 px-2">
                            <div className="modal__form__catagory row">
                                <div className="col-3"><div className="modal__form__catagory__lable">梯控裝置</div></div>
                                <div className="col-9">
                                    <div className="row">
                                        <div className="col-6">
                                            <label htmlFor="modalDeviceName" className="form-label">梯控裝置名稱*</label>
                                            <input
                                                type="text"
                                                className="form-control form-control-sm"
                                                id="modalDeviceName"
                                                name="modalDeviceName"
                                                value={formValues.modalDeviceName}
                                                onChange={handleChange}
                                                required
                                            />
                                        </div>
                                        <div className="col-6">
                                            <label htmlFor="modalDeviceType" className="form-label">設定類型*</label>
                                            <div className="d-flex align-content-center">
                                                <div className="form-check">
                                                    <input
                                                        className="form-check-input"
                                                        id="modalDeviceTypeM"
                                                        name="modalDeviceType"
                                                        type="radio"
                                                        value={formValues.modalDeviceType}
                                                        checked={formValues.modalDeviceType === 'M'}
                                                        onChange={handleChange}
                                                        data-checkbox-group="required"
                                                    />
                                                    <label className="form-check-label small" htmlFor="modalDeviceTypeMQTT"> MQTT </label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="modal__form__catagory row">
                                <div className="col-3"><div className="modal__form__catagory__lable">設定控制碼*</div></div>
                                <div className="col-9">
                                    <div className="row">
                                        <div className="col-6">
                                            <label htmlFor="modalDeviceHostname" className="form-label">電梯編號*</label>
                                            <div className="input-group input-group-sm">
                                                <input
                                                    type="text"
                                                    className="form-control form-control-sm"
                                                    id="modalDeviceHostname"
                                                    name="modalDeviceHostname"
                                                    value={formValues.modalDeviceHostname}
                                                    onChange={handleChange}
                                                    required
                                                />
                                            </div>
                                        </div>
                                        <div className="col-6">
                                            <label htmlFor="modalDeviceMac" className="form-label">MAC Address</label>
                                            <div className="input-group input-group-sm">
                                                <input
                                                    type="text"
                                                    className="form-control form-control-sm"
                                                    id="modalDeviceMac"
                                                    name="modalDeviceMac"
                                                    value={formValues.modalDeviceMac}
                                                    onChange={handleChange}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-6">
                                            <button type="button" className="btn btn-outline-secondary btn-sm" onClick={syncControlDeviceMac}>同步MAC address</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-12">
                                    <div className="alert alert-warning global-invalid-feedback" style={{ display: invalidShow }}></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-cancel" data-bs-dismiss="modal">取消</button>
                        <button type="submit" className="btn btn-primary">儲存</button>
                    </div>
                </form>
            </div>
        </div>
    );
});

export default ControlDeviceModal;